const state = {
  employee: {},
  actualLeftTabInProfileForm: ""
};

const getters = {
  getEmployee: (state) => state.employee,
  getActualLefTab: (state) => state.actualLeftTabInProfileForm
};

const mutations = {
  changeEmployee: (state, employee) => {
    state.employee = employee;
  },
  changeActualLefTab: (state, actualLeftTabInProfileForm) => {
    state.actualLeftTabInProfileForm = actualLeftTabInProfileForm;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
